"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import ErrorPage from "@/app/components/errorPage";
import "./globals.css";

/**
 * 根 layout / 模板级错误时替换整棵文档树；须自带 html/body。
 * 常见：根 layout 渲染失败等，与 `error.tsx`、RootErrorBoundary 互补。
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error, {
      tags: { errorBoundary: "global-error" },
      extra: { digest: error.digest },
    });
  }, [error]);

  return (
    <html lang="en">
      <body>
        <ErrorPage errorMsg={error.message || ""} canRetry onRetry={reset} />
      </body>
    </html>
  );
}
